import { useState } from "react";
import ResetPasswordModal from "./modals/ResetPasswordModal";

export default function ForceResetPasswordBlock() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-4 p-6 bg-white shadow-md rounded-md">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900">
            Reset Password Required
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Because your account was created by a teacher with a weak password,
            it is required to create a new one before accessing this content.
          </p>
          <button
            onClick={() => setShowModal(true)}
            className="mt-4 w-full py-2 px-4 rounded-md bg-indigo-500 text-white shadow-sm hover:bg-indigo-600 focus:ring focus:ring-indigo-300"
          >
            Reset Password Now
          </button>
        </div>

        <ResetPasswordModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            window.location.reload();
          }}
        />
      </div>
    </div>
  );
}
